import { render, staticRenderFns } from "./LogisticsView.vue?vue&type=template&id=275b6d16&scoped=true&"
import script from "./LogisticsView.vue?vue&type=script&lang=js&"
export * from "./LogisticsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275b6d16",
  null
  
)

export default component.exports